import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axios from 'axios';

// Initial state
const initialState = {
  discrepancies: [],
  isLoading: false,
  error: null,
};

export const slice = createSlice({
  name: "discrepancyLog",
  initialState,
  reducers: {
    // Set discrepancy log data in redux
    setDiscrepancyData(state, action) {
      state.discrepancies = action.payload;
      state.isLoading = false;
    },

    // Start loading state
    startLoading(state) {
      state.isLoading = true;
    },

    // Handle error
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { startLoading } = slice.actions;

export default slice.reducer;

// Get all discrepancy log entries
export function getDiscrepancyLog() {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${API_URL}/api/discrepancy_log`);
      console.log(response.data.data)
      dispatch(slice.actions.setDiscrepancyData(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Resolve a discrepancy log entry
export function resolveDiscrepancy(logId) {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`${API_URL}/api/discrepancy_log/resolve/${logId}`);
      // Refresh the discrepancy log data after resolving
      dispatch(getDiscrepancyLog());
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
} 